import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppSidebarHeader } from './app-sidebar-header.component';

@NgModule({
  declarations: [
    AppSidebarHeader
  ],
  imports: [
    BrowserModule
  ],
  exports: [
    AppSidebarHeader
  ]
})
export class AppSidebarHeaderModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/app-sidebar/app-sidebar-header/app-sidebar-header.module.ts